var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollege(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 96,
    viewBox: "0 0 90 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5944,
    r: 39,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6148 50.8424V55.5944H31.5708V51.8144L41.2908 42.6344C42.3228 41.6504 43.0188 40.8104 43.3788 40.1144C43.7388 39.3944 43.9188 38.6864 43.9188 37.9904C43.9188 36.9824 43.5708 36.2144 42.8748 35.6864C42.2028 35.1344 41.2068 34.8584 39.8868 34.8584C38.7828 34.8584 37.7868 35.0744 36.8988 35.5064C36.0108 35.9144 35.2668 36.5384 34.6668 37.3784L30.4188 34.6424C31.4028 33.1784 32.7588 32.0384 34.4868 31.2224C36.2148 30.3824 38.1948 29.9624 40.4268 29.9624C42.2988 29.9624 43.9308 30.2744 45.3228 30.8984C46.7388 31.4984 47.8308 32.3624 48.5988 33.4904C49.3908 34.5944 49.7868 35.9024 49.7868 37.4144C49.7868 38.7824 49.4988 40.0664 48.9228 41.2664C48.3468 42.4664 47.2308 43.8344 45.5748 45.3704L39.7788 50.8424H50.6148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.503 68.819C52.1409 46.6559 77.8016 46.8515 85.144 48.8189C83.108 56.4174 69.5126 79.4946 50.503 68.819Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9671 66.8189L80.3808 51.5689M50.503 68.819C52.1409 46.6559 77.8016 46.8515 85.144 48.8189C83.108 56.4174 69.5126 79.4946 50.503 68.819Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1633 63.819L61.5425 54.9398",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9829 59.8814L67.9732 52.4537M72.6946 56.0064L74.0215 51.0546",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1998 75.4815C70.1998 71.2815 66.7998 67.7815 62.4998 67.7815C61.8998 67.7815 61.1998 67.8815 60.5998 67.9815C60.2998 63.9815 56.9998 60.8815 52.8998 60.8815C48.7998 60.8815 45.4998 64.0815 45.1998 67.9815C44.6998 67.8815 44.0998 67.7815 43.4998 67.7815C39.1998 67.7815 35.7998 71.1815 35.7998 75.4815C35.7998 78.6815 37.7998 81.4815 40.5998 82.5815C39.8998 83.7815 39.3998 85.1815 39.3998 86.6815C39.3998 90.8815 42.7998 94.3815 47.0998 94.3815C49.4998 94.3815 51.5998 93.2815 52.9998 91.6815C54.3998 93.3815 56.4998 94.3815 58.8998 94.3815C63.0998 94.3815 66.5998 90.9815 66.5998 86.6815C66.5998 85.1815 66.1998 83.7815 65.3998 82.5815C68.1998 81.4815 70.1998 78.6815 70.1998 75.4815Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 76.4816C63.0523 76.4816 63.5 76.0339 63.5 75.4816C63.5 74.9293 63.0523 74.4816 62.5 74.4816C61.9477 74.4816 61.5 74.9293 61.5 75.4816C61.5 76.0339 61.9477 76.4816 62.5 76.4816Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69.5814C53.5523 69.5814 54 69.1337 54 68.5814C54 68.0291 53.5523 67.5814 53 67.5814C52.4477 67.5814 52 68.0291 52 68.5814C52 69.1337 52.4477 69.5814 53 69.5814Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3999 70.8815C57.7999 68.8815 60.0999 67.7815 62.4999 67.7815C66.6999 67.7815 70.1999 71.2815 70.1999 75.4815C70.1999 78.6815 68.1999 81.3815 65.4999 82.5815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3 79.3815C64.4 80.3815 66.6 83.3815 66.6 86.6815C66.6 90.8815 63.1 94.3815 58.9 94.3815C56.6 94.3815 54.4 93.2815 53 91.5815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7999 86.6815C54.7999 90.8815 51.2999 94.3815 47.0999 94.3815C42.8999 94.3815 39.3999 90.8815 39.3999 86.6815C39.3999 85.1815 39.7999 83.7815 40.5999 82.5815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8998 82.7815C45.0998 83.0815 44.2998 83.1815 43.4998 83.1815C39.2998 83.1815 35.7998 79.6815 35.7998 75.4815C35.7998 71.2815 39.2998 67.7815 43.4998 67.7815C44.0998 67.7815 44.7998 67.8815 45.3998 67.9815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7998 73.0815C45.7998 71.7815 45.2998 70.1815 45.2998 68.5815C45.2998 64.3815 48.7998 60.8815 52.9998 60.8815C56.8998 60.8815 60.1998 63.8815 60.5998 67.7815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76.4814V71.9814",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9998 77.8815L46.7998 76.5815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8 80.1815L49 84.0815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3999 77.7815L59.0999 76.5815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1997 80.1815L56.7997 83.8815",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9999 80.6814C54.1597 80.6814 55.0999 79.7412 55.0999 78.5814C55.0999 77.4216 54.1597 76.4814 52.9999 76.4814C51.8401 76.4814 50.8999 77.4216 50.8999 78.5814C50.8999 79.7412 51.8401 80.6814 52.9999 80.6814Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 76.4816C44.0523 76.4816 44.5 76.0339 44.5 75.4816C44.5 74.9293 44.0523 74.4816 43.5 74.4816C42.9477 74.4816 42.5 74.9293 42.5 75.4816C42.5 76.0339 42.9477 76.4816 43.5 76.4816Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0996 87.6815C47.6519 87.6815 48.0996 87.2338 48.0996 86.6815C48.0996 86.1292 47.6519 85.6815 47.0996 85.6815C46.5473 85.6815 46.0996 86.1292 46.0996 86.6815C46.0996 87.2338 46.5473 87.6815 47.0996 87.6815Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8999 87.6815C59.4522 87.6815 59.8999 87.2338 59.8999 86.6815C59.8999 86.1292 59.4522 85.6815 58.8999 85.6815C58.3476 85.6815 57.8999 86.1292 57.8999 86.6815C57.8999 87.2338 58.3476 87.6815 58.8999 87.6815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollege);
export default __webpack_public_path__ + "static/media/college.9bd2b756d8a58d9c1c596c70d80d3885.svg";
export { ForwardRef as ReactComponent };